module.exports = __webpack_public_path__ + "static/media/03-collection.c1836ecd.png";